import { SvgIcon, SvgIconProps } from '@mui/material';

export const OfficeLogoIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} width="20" height="22" viewBox="0 0 20 22">
            <path
                fillRule="evenodd"
                d="M12.713 0L1 4.329v13.24l11.713 4.21 6.366-1.919V2.037L12.713 0zM5.074 15.786V5.347l7.64-1.782v15.413L1 17.568l4.074-1.782z"
            />
        </SvgIcon>
    );
};
